export default __webpack_public_path__ + "static/media/creditCard.404a12cc.svg";